module.exports = __webpack_public_path__ + "img/sharp-example5.dc1f2ccb.jpg";